// Routes for the app part, rekisteri.testamenttikeskus.fi, these should not be indexed, see /api/robots
const ROUTES = {
    AUTH: {
        BASE: '/kirjautuminen',
        HANDLER: '/kirjautuminen/kasittelija',
        SIGNOUT: '/kirjautuminen/ulos'
    },
    WILL: {
        BASE: '/hautajaistestamentti',
        MANAGE: '/hautajaistestamentti/hallinnoi',
        PAYMENT: '/hautajaistestamentti/maksu',
        PAYMENT_CONFIRMATION: '/hautajaistestamentti/maksu/vahvistus',
        THANK_YOU: '/hautajaistestamentti/kiitos',
    },
    WILL_REGISTRATION: {
        BASE: '/testamentti-rekisteri',
        MANAGE: '/testamentti-rekisteri/hallinnoi',
        PAYMENT: '/testamentti-rekisteri/maksu',
        PAYMENT_CONFIRMATION: '/testamentti-rekisteri/maksu/vahvistus',
        THANK_YOU: '/testamentti-rekisteri/kiitos',
    },
    QUERY: {
        BASE: '/testamenttikysely',
        AUTH: '/testamenttikysely/kirjautuminen',
        PAYMENT: '/testamenttikysely/maksu',
        PAYMENT_CONFIRMATION: '/testamenttikysely/maksu/vahvistus',
        RESULTS: '/testamenttikysely/tulokset',
    }
};

// Routes for the landing page part, hautajaistestamentti.fi, these should be indexed, see /api/robots
export const ROUTES_LANDING = {
    FRONT_PAGE: '/',
    TERMS: '/ehdot',
    ABOUT: '/meista',
    PRIVACY_POLICY: '/tietosuojaseloste',
    COOKIES: '/evasteet',
}

// URLs for the app part, rekisteri.testamenttikeskus.fi, these should not be indexed, see /api/robots
export const URLS = {
    DEVELOPMENT: 'http://rekisteri.testamenttikeskus:3000',
    PREVIEW: 'https://dev.testamenttikeskus.fi',
    PRODUCTION: 'https://rekisteri.testamenttikeskus.fi'
}

// URLs for the landing page part, hautajaistestamentti.fi, these should be indexed on production, see /api/robots
export const URLS_LANDING = {
    DEVELOPMENT: 'http://hautajaistestamentti:3000',
    PREVIEW: 'https://dev.hautajaistestamentti.fi',
    PRODUCTION: 'https://hautajaistestamentti.fi',
}


export default ROUTES;
